var exports = {
  "P": "MentionRenderer.module__label___emd3Tl",
  "p": "MentionRenderer.module__channelIcon___emd3Tl",
};

module.exports = exports;
